/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-expressions */
import { useEffect, useRef, useContext, useState } from '@wordpress/element';
import * as d3 from 'd3';
import metro_shape from '../data/middle-class-metro-map-geo.json';
import state_shape from '../data/USA.json';
import metro_data from '../data/middle-class-metro.json';
import UserContext from '../context/context';
import Tooltip from './Tooltip';

const Map = () => {
    const context = useContext(UserContext);
    const { classTier, currentAttribute } = context;
    const [hover, setHover] = useState([null]);
    const [buttonID, setButtonID] = useState();

    const [displayTooltip, setTooltip] = useState(['none']);
    const [dimensions, setDimensions] = useState([0, 0]);
    const container = useRef(null);
    const margin = { top: 10, left: 10, bottom: 10, right: 10 };
    const attributeArray = [];

    const mapInit = () => {
        d3.selectAll('#map svg').remove();

        const w = container.current.offsetWidth;
        const width = w - margin.left - margin.right;
        const mapRatio = 0.7;
        const height = width * mapRatio;

        const projection = d3
            .geoAlbersUsa()
            .scale(width * 1.3)
            .translate([width / 2, height / 2.3]);

        const path = d3
            .geoPath() // create path generator function
            .projection(projection); // add our define projection to it

        const zoom = d3.zoom().scaleExtent([0.8, 4]);

        const svg = d3
            .select(container.current)
            .append('svg') // append a svg to our html div to hold our map
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .call(zoom);
        // .append('g');

        const g = svg.append('g');

        const zoomed = ({ transform }) => {
            g.attr(
                'transform',
                `translate(${transform.x},0) scale(${transform.k},1)`,
            );

            g.attr('transform', transform);
        };

        svg.call(
            d3
                .zoom()
                .scaleExtent([0.8, 8])
                .on('zoom', zoomed),
        );

        function interpolateZoom(translate, scale) {
            return d3
                .transition()
                .duration(350)
                .tween('zoom', function() {
                    const iTranslate = d3.interpolate(
                        zoom.translate(),
                        translate,
                    );
                    const iScale = d3.interpolate(zoom.scale(), scale);
                    return function(t) {
                        zoom.scale(iScale(t)).translate(iTranslate(t));
                        zoomed();
                    };
                });
        }

        function zoomClick() {
            let direction = 1;
            const factor = 0.2;
            let target_zoom = 1;
            const center = [width / 2, height / 2];
            const extent = zoom.scaleExtent();
            const translate = zoom.translate();
            let translate0 = [];
            let l = [];
            const view = { x: translate[0], y: translate[1], k: zoom.scale() };

            d3.event.preventDefault();
            direction = 'zoom_in' === buttonID;
            target_zoom = zoom.scale() * (1 + factor * direction);

            if (target_zoom < extent[0] || target_zoom > extent[1]) {
                return false;
            }

            translate0 = [
                (center[0] - view.x) / view.k,
                (center[1] - view.y) / view.k,
            ];
            view.k = target_zoom;
            l = [
                translate0[0] * view.k + view.x,
                translate0[1] * view.k + view.y,
            ];

            view.x += center[0] - l[0];
            view.y += center[1] - l[1];

            interpolateZoom([view.x, view.y], view.k);
        }

        // d3.selectAll('.zoom').on('click', zoomClick);

        const metro_shapes = metro_shape.features;
        const state_shapes = state_shape.features;

        for (const j in metro_data) {
            for (const i in metro_shapes) {
                if (
                    metro_shapes[i].properties.GEOID === metro_data[j].GeoFips
                ) {
                    for (const k in metro_data[j]) {
                        if ('NAME' !== k && 'name' !== k) {
                            if (-1 === attributeArray.indexOf(k)) {
                                attributeArray.push(k);
                            }
                            metro_shapes[i].properties[k] = Number(
                                metro_data[j][k],
                            );
                        }
                    }
                    break;
                }
            }
        }

        g.selectAll('.state') // select country objects (which don't exist yet)
            .data(state_shapes) // bind data to these non-existent objects
            .enter()
            .append('path') // prepare data to be appended to paths
            .attr('class', 'state') // give them a class for styling and access later
            .attr(
                'id',
                function(d) {
                    return `code_${d.id}`;
                },
                true,
            ) // give each a unique id for access later
            .attr('d', path); // create them using the svg path generator defined above

        g.selectAll('.metro') // select country objects (which don't exist yet)
            .data(metro_shape.features) // bind data to these non-existent objects
            .enter()
            .append('path') // prepare data to be appended to paths
            .attr('class', 'metro') // give them a class for styling and access later
            .attr('id', d => `code_${d.id}`, true) // give each a unique id for access later
            .attr('d', path); // create them using the svg path generator defined above

        const select = d3.select('select');

        g.selectAll('.metro') // select all the metro_shapes and prepare for a transition to new values
            .style('fill', function(d) {
                // fill colors for metro_shapes
                const gap = d.properties[attributeArray[currentAttribute]]; // find the current number
                if (1 === currentAttribute) {
                    // Lower
                    if (25 > gap) {
                        return '#d1e9e4';
                    }
                    if (30 < gap) {
                        return '#005645';
                    }
                    if (25 < gap || 30 > gap) {
                        return '#64b6aa';
                    }

                    return '#ffffff';
                }
                if (2 === currentAttribute) {
                    // Middle
                    if (55 < gap) {
                        return '#6E7537';
                    }
                    if (50 > gap) {
                        return '#EAECD8';
                    }
                    if (50 < gap || 55 > gap) {
                        return '#C2C98B';
                    }

                    return '#ffffff';
                }
                if (3 === currentAttribute) {
                    // Upper
                    if (20 < gap) {
                        return '#9E7F2D';
                    }
                    if (15 > gap) {
                        return '#F6EED6';
                    }
                    if (15 < gap || 20 > gap) {
                        return '#E4CB83';
                    }

                    return '#ffffff';
                }
            })
            .on('mouseover', (e, d) => {
                setDimensions([e.layerX, e.layerY]);
                const name = d.properties.NAME;
                const gap = d.properties[attributeArray[currentAttribute]];
                const up_share = d.properties[attributeArray[3]].toFixed();
                const mid_share = d.properties[attributeArray[2]].toFixed();
                const low_share = d.properties[attributeArray[1]].toFixed();
                const up_change = Math.round(d.properties[attributeArray[6]]); // No -0
                const mid_change = Math.round(d.properties[attributeArray[5]]);
                const low_change = Math.round(d.properties[attributeArray[4]]);
                const pos_gap = Math.abs(gap);
                const data = {
                    name,
                    gap,
                    up_share,
                    mid_share,
                    low_share,
                    up_change,
                    mid_change,
                    low_change,
                    pos_gap,
                };
                setHover(data);
                setTooltip('block');
            })
            .on('mouseleave', () => {
                setHover(null);
                setTooltip('none');
            });
    };

    useEffect(() => {
        mapInit();
    }, [classTier]);

    return (
        <>
            <div id="map" ref={container}>
                {/* <div className="zoom_buttons">
                    <button
                        className="zoom"
                        id="zoom_in"
                        type="button"
                        onClick={() => setButtonID('zoom_in')}
                    >
                        +
                    </button>
                    <button
                        className="zoom"
                        id="zoom_out"
                        type="button"
                        onClick={() => setButtonID('zoom_out')}
                    >
                        -
                    </button>
                </div> */}
            </div>
            {hover && (
                <Tooltip
                    text={hover}
                    display={displayTooltip}
                    dimensions={dimensions}
                />
            )}
        </>
    );
};

export default Map;
